export function isStandaloneDisplayMode() {
  const navigatorWithStandalone = navigator as Navigator & { standalone?: boolean };

  return (typeof window.matchMedia === 'function'
    && window.matchMedia('(display-mode: standalone)').matches)
    || navigatorWithStandalone.standalone === true;
}
